module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Light.woff2?dd76500e83bacab8849f153e91d36584";